interface PostcodeMapProps {
  latitude: number
  longitude: number
  postcode: string
  zoom?: number
}

export default function PostcodeMap({ latitude, longitude, postcode, zoom = 14 }: PostcodeMapProps) {
  const delta = zoom >= 14 ? 0.015 : 0.04
  const bbox = [
    longitude - delta,
    latitude - delta,
    longitude + delta,
    latitude + delta,
  ].join(",")

  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${latitude},${longitude}`

  return (
    <div className="overflow-hidden rounded-xl border border-stone">
      <iframe
        title={`Map of ${postcode}`}
        src={src}
        width="100%"
        height="300"
        className="block border-0"
        loading="lazy"
        referrerPolicy="no-referrer"
      />
      <div className="flex items-center justify-between bg-white px-4 py-2">
        <span className="text-xs text-slate">
          {postcode} &middot; {latitude.toFixed(4)}, {longitude.toFixed(4)}
        </span>
        <a
          href={`https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=${zoom}/${latitude}/${longitude}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-medium text-red hover:text-charcoal transition-colors"
        >
          View larger map
        </a>
      </div>
    </div>
  )
}
